export const GIFCON_APP_API = import.meta.env.VITE_GIFCON_APP_API_URL ?? '/api/gifcon-app';
